import { useValidateImage } from '@common/hooks';
import styled from '@emotion/styled';
import React from 'react';

interface Props {
  code?: string | null;
  image_url?: string | null;
  webp_image_url?: string | null;
}

export const SelectBoxItemPreview: React.FC<React.PropsWithChildren<Props>> = ({ code, image_url, webp_image_url }) => {
  const { isImageValid } = useValidateImage(image_url);
  // TODO: 추후 static 이미지 마이그레이션 마치면 제거
  const { isImageValid: isWebpImageValid } = useValidateImage(webp_image_url);

  return (
    <>
      {image_url && isImageValid ? (
        <OptionPreview>
          <OptionImage>
            {isWebpImageValid && <source srcSet={webp_image_url || ''} type='image/webp' />}
            <Image src={image_url} alt='상품 옵션 이미지' />
          </OptionImage>
        </OptionPreview>
      ) : code ? (
        <OptionPreview>
          <ColorCode code={code} />
        </OptionPreview>
      ) : null}
    </>
  );
};

const OptionPreview = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
`;

const OptionImage = styled.picture`
  width: 100%;
  height: 100%;
  border-radius: 4px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ColorCode = styled.span<{ code: string | null }>`
  border: 1px solid rgba(0, 0, 0, 0.08);
  width: 18px;
  height: 18px;
  border-radius: 12px;
  ${({ code }) => code && `background-color: ${code}`}
`;
